const TOKEN_STORAGE_KEY = 'gitlab_api_token';

export const getGitlabSavedToken = () => {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY) || '';
  } catch (e) {
    return '';
  }
};

export const saveGitlabToken = (token) => {
  try {
    if (token && token.trim() !== '') {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
    }
  } catch (e) {}
};

export const clearGitlabToken = () => {
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch (e) {}
};
